import { render } from "./AuraChatLayout.vue?vue&type=template&id=46dd8a3c&scoped=true&ts=true"
import script from "./AuraChatLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraChatLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AuraChatLayout.vue?vue&type=style&index=0&id=46dd8a3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dd8a3c"],['__file',"src/views/pages/aura/AuraChatLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46dd8a3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46dd8a3c', __exports__)) {
    api.reload('46dd8a3c', __exports__)
  }
  
  module.hot.accept("./AuraChatLayout.vue?vue&type=template&id=46dd8a3c&scoped=true&ts=true", () => {
    api.rerender('46dd8a3c', render)
  })

}


export default __exports__